import { html } from "lit-html";
import { Base } from "@escapio/shared/components/dialogs/Base";
import { data as payload } from "@escapio/shared/state/payload";
import { SIZE_MOBILE, SIZE_TABLET } from "@escapio/portal/dom/screen";
import "@escapio/shared/components/Picture";
import { getSrcSet, getImageUrl } from "@escapio/shared/components/Picture";
import "@escapio/portal/components/newsletter/Form";
import unsaferHTML from "@escapio/shared/unsaferHTML";
import checkmarkSvg from "@docroot/public/img/linearicons/checkmark.svg";

export class NewsletterPopupDialog extends Base {
	constructor() {
		super();
		this.node.classList.add(
			"dialog--popup-desktop",
			"dialog--popup-with-picture",
		);
		this.data = {
			desktopMedia: null,
			mobileMedia: null,
			title: null,
			text: null,
			link: null,
			linkLabel: null,
		};
		this.successful = false;
	}

	getTemplateHeaderRight() {
		return html`<button
			class="dialog__header-close close-icon close-icon--with-hover close-icon--large"
			@click=${this.hide}
		></button>`;
	}

	getTemplateContent() {
		return html`
			<picture class="newsletter-popup__picture">
				<source
					srcset="
						${getSrcSet(
							"article",
							this.data.mobileMedia,
							`${payload.grid[SIZE_MOBILE][1]}x`,
						)}
					"
					media="(max-width: ${payload.grid[SIZE_MOBILE][1]}px)"
				/>
				<source
					srcset="${getSrcSet("article", this.data.desktopMedia, "400x")}"
					media="(min-width: ${payload.grid[SIZE_TABLET][0]}px)"
				/>
				<img
					alt="${this.data.title}"
					src="${getImageUrl(
						"article",
						this.data.desktopMedia,
						`${payload.grid[SIZE_MOBILE][1]}x`,
					)}"
				/>
			</picture>
			<section class="newsletter-popup__form">
				<h2 class="newsletter-popup__heading">${this.data.title}</h2>
				<p class="newsletter-popup__text">${unsaferHTML(this.data.text)}</p>
				${this.successful
					? html`<p
							class="newsletter-popup__message message message--success message--colored"
						>
							<span class="bullit bullit--green message__icon"
								>${checkmarkSvg}</span
							>
							<span>${this.data.successMessage}</span>
						</p>`
					: html`<esc-newsletter-form
							location="Popup"
							colored-message
							@submitSuccess="${this.onSuccess}"
						></esc-newsletter-form>`}
				<p class="newsletter-popup__terms">
					<esc-click-tracker
						category="Newsletter"
						action="Klick Link im PopUp"
						label="${this.data.linkEventLabel}"
						><a href="${this.data.link}" target="_blank" rel="noopener">
							${this.data.linkLabel}
							<span class="fa fa-angle-right"></span> </a
					></esc-click-tracker>
				</p>
			</section>
		`;
	}

	show(data) {
		this.data = data;
		super.show();
	}

	onSuccess() {
		this.successful = true;
		this.render();
	}
}
